<template>
    <el-dialog :title="title" :visible.sync="dialogVisible" :width="dialogWidth" :class="{'show':show}">
        <slot></slot>
        <span slot="footer" class="dialog-footer">
            <el-button v-if="show" clas="button-size" @click="closeDialog">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
    export default {
        name: "showInfoDialog",
        props: {
            title: {
                type: String,
                default: ''
            },
            dialogWidth: {
                type: String,
                default: '800px'
            },
            show: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                dialogVisible: false
            };
        },
        methods: {
            open() {
                this.dialogVisible = true;
            },
            closeDialog(){
                this.dialogVisible = false;
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/dialog/ShowInfoDialog.vue